import { render, staticRenderFns } from "./SmppConnectionsFilter.vue?vue&type=template&id=12bb6bd6&"
import script from "./SmppConnectionsFilter.vue?vue&type=script&lang=ts&"
export * from "./SmppConnectionsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports